// src/components/PrivacyDialog.js

import React from 'react';
// The 'Box' component has been removed from this import line
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button } from '@mui/material';

const PrivacyDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} scroll="paper">
      <DialogTitle>Privacy Statement for Zinlanka™</DialogTitle>
      <DialogContent dividers={true}>
        <Typography variant="body2" gutterBottom>
          <strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Typography>
        <br />
        <Typography gutterBottom>
          Your privacy is important to us. This privacy statement explains the personal data Zinlanka processes, how Zinlanka processes it, and for what purposes.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Data We Collect
        </Typography>
        <Typography gutterBottom>
          Zinlanka collects data to operate effectively and provide you with the best experiences. You provide some of this data directly when you sign in. We collect the following information from your Google Account upon authentication:
        </Typography>
        <ul>
          <li><Typography component="span"><strong>Display Name</strong></Typography></li>
          <li><Typography component="span"><strong>Email Address</strong></Typography></li>
          <li><Typography component="span"><strong>Profile Photo URL</strong></Typography></li>
          <li><Typography component="span"><strong>A unique Google User ID</strong></Typography></li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          How We Use Your Data
        </Typography>
        <Typography gutterBottom>
          We use the data we collect for one primary purpose: to provide and improve the Zinlanka chat service. This includes:
        </Typography>
        <ul>
            <li><Typography component="span">Displaying your profile information (name and photo) to you and your connections within the application.</Typography></li>
            <li><Typography component="span">Identifying you as the sender of messages and connection requests.</Typography></li>
            <li><Typography component="span">Allowing other users to find you via your email address to send a connection request.</Typography></li>
        </ul>

        <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Data Storage and Sharing
        </Typography>
        <Typography gutterBottom>
          All your personal data and conversation history are stored securely using Google's Firebase services. We do not share your personal data with any third-party companies or services.
        </Typography>

         <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Your Rights and Choices
        </Typography>
         <Typography gutterBottom>
          You have control over your personal data. At any time, you can use the "Edit Profile" feature to change your display name and profile photo.
        </Typography>

         <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
          Contact Us
        </Typography>
         <Typography gutterBottom>
          If you have any questions about this privacy statement, please contact us at [ kushannuvidu@gmail.com ].
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrivacyDialog;